export const LOAD_COMPLEMENTOS = "LOAD_COMPLEMENTOS";
export const SET_PAGE_COMPLEMENTO = "SET_PAGE_COMPLEMENTO";
export const SET_PERPAGE_COMPLEMENTO = "SET_PERPAGE_COMPLEMENTO";
export const SET_TOTAL_COMPLEMENTO = "SET_TOTAL_COMPLEMENTO";
export const SET_COMPLEMENTO = "SET_COMPLEMENTO";
export const LOADING_COMPLEMENTO = "LOADING_COMPLEMENTO";
export const SET_FILTRO_COMPLEMENTO = "SET_FILTRO_COMPLEMENTO";
